module.exports = __webpack_public_path__ + "static/footerLogo-fe1e4d3cd28dadbd51eb4178e7e8c8df.png";